import React from "react"
import {Select} from "@irati/ui/src/FormItem"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"

export enum WhoCanSeeCompanyBenefit {
  Tenant = "tenant",
  Team = "team",
  BusinessUnit = "businessUnit"
}

const buildOptions = (formatMessage: FormatMessage, showBUOption: boolean) => {
  const options = [
    {
      value: WhoCanSeeCompanyBenefit.Tenant,
      label: formatMessage({id: "admin.companyBenefits.whocansee.option.everyone"}, {tenantName: authentication.userTenant().public_name})
    },
    {value: WhoCanSeeCompanyBenefit.Team, label: formatMessage({id: "admin.companyBenefits.whocansee.option.teams"})}
  ]

  if (showBUOption) {
    return [
      ...options,
      {
        value: WhoCanSeeCompanyBenefit.BusinessUnit,
        label: formatMessage({id: "admin.companyBenefits.whocansee.option.countries"})
      }
    ]
  }
  return options
}

export type WhoCanSeeOnChange = (value: WhoCanSeeCompanyBenefit) => any

interface Props extends InjectIntl {
  value: WhoCanSeeCompanyBenefit
  onChange: WhoCanSeeOnChange
  showBUOption: boolean
}

const WhoCanSee: React.FC<Props> = (props) => {
  const {formatMessage, showBUOption} = props
  return (
    <Select
      label={formatMessage({id: "admin.companyBenefits.whocansee.label"})}
      options={buildOptions(formatMessage, showBUOption)}
      value={props.value}
      isClearable={false}
      onChange={props.onChange}
    />
  )
}

export default injectIntl(WhoCanSee)
